import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

class ProfileTrigger extends Component {
    
    handleOpenSidebar = ()=> {
        document.body.classList.add('sidebar-open')
    }

    render() {
        const { user } = this.props

        return (
            <button className="c-profile-trigger c-bare-btn" style={{backgroundImage: `url('${user.avatar.user_avatar}')`}} onClick={this.handleOpenSidebar}>
            </button>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user,
        sidebar: state.sidebar,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({ }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileTrigger)